
import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Card,
  CardHeader,
  CardContent,
  Hidden,
  Divider,
  Tooltip,
  Chip,
  OutlinedInput,

} from "@material-ui/core";
import Box from '@material-ui/icons/AddBox';
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { authStore } from "src/modules/auth";
import { usersAdminStore } from "..";
import { observer } from "mobx-react";
import { Loading } from "src/components/loading";
import { history } from "src/history.js";
import { withRouter } from "react-router";
import { validationsStore } from '../../../../validations';
import InfoIcon from '@material-ui/icons/Info';
import SelectChangeEvent from '@material-ui/core'

interface IAppInfo {
  app_id: number;
  App: string;
  AppRoles: any[]
}
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];

function getStyles(name: string, personName: readonly string[], theme: Theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const styles = createStyles({
  root: {
    width: "100%",
    height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    display: "flex",
    flexDirection: "column",
    overflow: 'hidden'
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  submitButton: {
    backgroundColor: "#2A2A55",
    border: "1px solid #2D4D73",
    color: "#FAFAFA",
  },
  tabRoot: {
    height: '100%'
  },

});

@observer
class UserRoles extends React.Component<any> {

  public state = {
    university_role_id: []
  }

  constructor(props: any) {
    super(props);

  }


  public togglePharmacyRole = (event: any) => {
    // MaterialSelect can only send in the id from the event handler, need to pull the full role object
    const fullPharmacyRole = this.props.allRoles.find((app: IAppInfo) => app.app_id === 1).AppRoles.filter((pharma_role: any) => pharma_role.pharmacy_role_id === event.target.value)
    validationsStore.runValidator('pharmacyRole', fullPharmacyRole)
    return usersAdminStore.togglePharmacyRole(fullPharmacyRole)
  }

  public toggleUniversityRole = (event: any, actionType: string) => {

    this.setState({ university_role_id: event.target.value });
    if (validationsStore.validator['universityRole'].validateFunctions[0].active === false) {
      validationsStore.validator['universityRole'].validateFunctions[0].active = true
    }
    let selectedId = event.target.value.map((item) => ({ university_role_id: item }))
    let data = this.props.allRoles.find((app: IAppInfo) => app.app_id === 2).AppRoles;
    let result = selectedId.map((item) => {
      let obj = data.find((o) => o.university_role_id === item.university_role_id);
      return { ...obj, ...item }
    })
    return usersAdminStore.toggleUniversityRole(result, actionType)
  }

  public universityRoleDisabled = (role: string) => {
    if (this.props.match.params.view_type === 'detail') {
      return true;
    }

    if (role === 'Student') {
      return true
    }

    return false

  }

  @action
  public toggleSkipCourses = () => {
    const val = this.props.currentUser.IntroCoursesComplete === 0 ? 1 : 0;
    this.props.currentUser.IntroCoursesComplete = val;
  }

  @action
  public toggleSkipPharmacyCourses = () => {
    const val = this.props.currentUser.PharmacyQualified === 0 ? 1 : 0;
    this.props.currentUser.PharmacyQualified = val;
  }

  componentDidMount() {
    let dataValue = this.props.currentUser.Apps[1].roles.map((role: any, index: number) => {
      return role.university_role_id;
    })
    this.setState({ university_role_id: dataValue });

  }


  public getAppCard(appObj: any) {
    const app_id = appObj.app_id;
    const { currentUser, classes } = this.props;

    const userAppInfo = currentUser.Apps.find((app: any) => app.app_id === app_id);
    if (!userAppInfo || !userAppInfo.Active) {
      return (
        <Card>
          <CardHeader title={appObj.App} />
          <CardContent>Not Registered</CardContent>
        </Card>
      )
    }
    switch (app_id) {
      case (1): { // Pharmacy
        // Pharmacy users have one role only, so it picks the only role in the array
        const selected = userAppInfo.roles[0] || { pharmacy_role_id: 0 };
        return (
          <Card>
            <CardHeader title='Pharmacy' />
            <CardContent>
              {/* <FormControl error={!!this.formErrors["auth_group_id"]}> */}
              {/* C-010 sort((a, b) => a.priority - b.priority) .charAt(0).toUpperCase() +
                            role?.PharmacyRoleName?.slice(1)} */}
              <FormControl error={!validationsStore.validator['pharmacyRole'].valid}>
                <InputLabel htmlFor={"user_role"} shrink={true}>
                  User Role
                </InputLabel>
                <Select
                  inputProps={{ name: "user_role", id: "user_role" }}
                  value={selected.pharmacy_role_id || 0}
                  classes={{ root: classes.roleSelect }}
                  // tslint:disable-next-line: jsx-no-lambda
                  onChange={(e) => this.togglePharmacyRole(e)}
                  disabled={this.props.match.params.view_type === 'detail'}
                >
                  {appObj.AppRoles.filter((role: any) => ((role.priority)+1) >= authStore.currentUser.portal_role_id)?.sort((a, b) => a.priority - b.priority)?.map((role: any, index: number) => { // C-010
                    return (
                      <MenuItem key={index} value={role.pharmacy_role_id}> 
                        {role?.PharmacyRoleName?.charAt(0).toUpperCase() +
                            role?.PharmacyRoleName?.slice(1)} 
                      </MenuItem>
                    );
                  })}
                </Select>
                <FormHelperText>
                  {!validationsStore.validator["pharmacyRole"].valid
                    ? validationsStore.validator["pharmacyRole"].errorMessage.join()
                    : " "}
                </FormHelperText>
              </FormControl>
              <Divider />
              {this.props.match.params.view_type === "create" ?
                <React.Fragment>
                  <div style={{ display: 'block', float: 'left' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          disabled={this.props.match.params.view_type === 'detail'}
                          style={{ marginLeft: '5px' }}
                          checked={this.props.currentUser.PharmacyQualified === 1}
                          // tslint:disable-next-line: jsx-no-lambda
                          onChange={() => this.toggleSkipPharmacyCourses()}
                        // color="primary"
                        />
                      }
                      label={'Skip Intro Courses'}
                    />
                  </div>
                  <div style={{ display: 'block', float: 'right', marginTop: '10px' }}>
                    <Tooltip
                      style={{ display: this.props.match.params.view_type !== 'create' ? 'none' : '' }}
                      title={'Allow this user to access Pharmacy app without needing to complete the introductory courses'}
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div>
                </React.Fragment>
                :
                null
              }

            </CardContent>
          </Card>
        )
      }
      case (2): { // University
        {
          const selected = currentUser.Apps.filter((a: any) => a.app_id === app_id)[0].roles.filter((app_role: any) => app_role.role_id === this.state.university_role_id).length > 0
          return (
            <Card>
              <CardHeader title='University' />
              <CardContent>
                <div className={classes.root}>
                  <FormControl className={classes.formControl}>
                    <InputLabel id="demo-multiple-chip-label">Chip</InputLabel>
 
                    <Select
                      id="demo-multiple-chip"
                      multiple
                      value={this.state?.university_role_id}
                      onChange={(e) => this.toggleUniversityRole(e, selected ? 'drop' : 'add')}
                      MenuProps={MenuProps}
                    >
                      {(appObj.AppRoles || []).map((role: any, index: number) => (
                        <MenuItem
                          key={index}
                          value={role.university_role_id}
                        >
                          {role.UniversityRoleName}
                        </MenuItem>
                      ))}
                    </Select>
 
                  </FormControl>
                </div>
 
                <Divider />
                <div style={{ display: 'block', float: 'left' }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={this.props.match.params.view_type === 'detail'}
                        style={{ marginLeft: '5px' }}
                        checked={this.props.currentUser.IntroCoursesComplete === 1}
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={() => this.toggleSkipCourses()}
                      // color="primary"
                      />
                    }
                    label={'Skip Intro Courses'}
                  />
                </div>
                <div style={{ display: 'block', float: 'right', marginTop: '10px' }}>
                  <Tooltip
                    title={'Allow this user to access full University app without needing to complete the introductory courses'}
                  >
                    <InfoIcon />
                  </Tooltip>
                </div>
              </CardContent>
            </Card>
          );
        }
      }
      case (3): { // Chat
        return (
          <Card>
            <CardHeader title='Chat' />
            <CardContent>
              {appObj.AppRoles.map((role: any) => {
                return (
                  <div key={role.role_id}>{role.RoleName}</div>
                )
              })}
            </CardContent>
          </Card>
        )
      }
      default: {
        return <div>no card</div>
      }
    }
  }

  public render() {
    const { classes, mode, allRoles, currentUser } = this.props;

    if (
      !this.props.currentUser
    ) {
      return <Loading />;
    } else {
      return (
        <div className={classes.root}>
          <Grid container={true} spacing={8}>
            {allRoles.map((app: any) => {
              return (<Grid item={true} xs={4} key={app.app_id}>{this.getAppCard(app)}</Grid>)
            })}
          </Grid>
        </div>
      );
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(UserRoles)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/UsersAdmin/components/UsersRoles.tsx